import React from 'react';

export default [
	{
		title: <span style={{ display: 'block', textIndent: '-9999px' }}>Gift Card</span>,
		colSpan: 2,
		align: 'left',
		width: '15%'
	},
	{
		title: 'Product',
		colSpan: 3,
		align: 'left',
		width: '25%'
	},
	{
		title: 'Price',
		colSpan: 1,
		align: 'left',
		width: '15%'
	},
	{
		title: 'Quantity',
		colSpan: 1,
		align: 'center'
	},
	{
		title: 'Subtotal',
		colSpan: 1,
		align: 'right',
		width: '15%'
	}
];
